import { FC, memo } from 'react';
import { Menu } from '@chakra-ui/react';

import { MenuItemProps } from './types/MenuItemProps';

const MenuItemComponent: FC<MenuItemProps> = ({ children, ...props }) => (
  <Menu.Item {...props}>{children}</Menu.Item>
);

export const MenuItem = memo(MenuItemComponent);
